import { useState } from 'react';
import { ClientWebhooksRequest, WebhooksEvents } from 'vopay';
import { useApi } from '#shared/providers/Api';

export default function useFetchWebhookNotifications() {
  const api = useApi();
  const [fetchingWebhookNotifications, setFetchingWebhookNotifications] = useState(false);
  const [webhookNotifications, setWebhookNotifications] = useState<WebhooksEvents[]>();
  const [totalRecords, setTotalRecords] = useState(0);

  async function fetchWebhookNotifications(params: ClientWebhooksRequest & { Limit: number; Offset: number }) {
    try {
      setFetchingWebhookNotifications(true);
      const res = await api.fetchWebhooks(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setWebhookNotifications(Object.values(res.WebhookNotifications || {}));
      setTotalRecords(res.Pagination?.TotalRecords || 0);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetchingWebhookNotifications(false);
    }
  }

  return { fetchingWebhookNotifications, webhookNotifications, totalRecords, fetchWebhookNotifications };
}
